
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 18.571l4.286-.946-3.34-3.34zM17.635 5.58a3.173 3.173 0 00.936-2.258 3.166 3.166 0 00-.935-2.259L17.51.935A3.172 3.172 0 0015.25 0h-.001c-.854 0-1.655.333-2.259.937L1.43 12.524l4.619 4.619L17.635 5.58z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/update.svg